<template lang="pug">
    div
        span(v-if="empty" slot="empty")
            i.text-muted {{ emptyText }}

        span(v-else slot="non-empty")
            | {{ display }}
</template>

<script>
export default {
    props: {
        emptyText: {
            type: String,
            required: false,
            default: 'Empty',
        },

        label: {
            type: String,
            required: false,
            default: 'name',
        },

        value: {
            type: null,
            required: true,
        },
    },

    computed: {
        display() {
            if (this.value instanceof Object) {
                return this.value[this.label];
            }

            return this.value;
        },

        empty() {
            return this.value == null;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/optional-cell-value.vue